import script from "./CapacitacionView.vue?vue&type=script&setup=true&lang=js"
export * from "./CapacitacionView.vue?vue&type=script&setup=true&lang=js"

import "./CapacitacionView.vue?vue&type=style&index=0&id=0af6c3c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af6c3c4"]])

export default __exports__